module.exports = __webpack_public_path__ + "static/media/ic_privacy_policy_un_checked.e50e6f0c.svg";